import * as React from "react";
import { forwardRef } from "react";
const SvgIcMap24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 19L15 23L8 19L1 23V4L9 1L15 4L22 1V19ZM9 17.2676L14 20.124V5.73535L9 3.23535V17.2676ZM16 5.74707V20.124L20 17.8389V4.03223L16 5.74707ZM3 5.38574V19.5537L7 17.2676V3.88574L3 5.38574Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcMap24);
export { ForwardRef as ReactComponent };
